module.exports = "<p>\n  car-list works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/car/car-list/car-list.component.html
// module id = 156
// module chunks = 1